import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types";

interface NewsCardProps {
  article: NewsArticle;
}

const categoryStyle: Record<string, string> = {
  资讯: "bg-accent-100 text-accent-800",
  花絮: "bg-secondary-100 text-secondary-900",
  评论: "bg-primary-100 text-primary-800",
};

export default function NewsCard({ article }: NewsCardProps) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300 cursor-pointer"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
        <img
          src={article.cover}
          alt={article.title}
          title={article.title}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-md px-2.5 py-1 text-[11px] font-medium ${
            categoryStyle[article.category] ?? "bg-secondary-100 text-secondary-900"
          }`}
        >
          {article.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
          <i className="ri-calendar-line"></i>
          {article.publishedAt}
        </span>
        <h3 className="mt-2.5 line-clamp-2 text-base font-medium leading-snug text-foreground-950 transition-colors group-hover:text-accent-700">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-3 flex-1 text-xs leading-relaxed text-foreground-600">{article.summary}</p>
        <span className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}